var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_805",
    "data-name": "Rectangle 805",
    width: 70,
    height: 70,
    transform: "translate(819 1303)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_63",
    "data-name": "Mask Group 63",
    transform: "translate(-819 -1303)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "quick_reference_all_FILL0_wght400_GRAD0_opsz48",
    d: "M124.665,180.665v0Zm7.7,31.1h14.385a22.241,22.241,0,0,1,1.866-2.488,17.968,17.968,0,0,1,2.255-2.177H132.363Zm0,13.218h12.13q-.233-1.166-.35-2.333a14.026,14.026,0,0,1-.039-2.333H132.363Zm-7.7,13.218A4.783,4.783,0,0,1,120,233.539V180.665A4.783,4.783,0,0,1,124.665,176h28.069l17.028,17.028V205a17.188,17.188,0,0,0-2.255-.933,18.245,18.245,0,0,0-2.41-.622v-8.32H150.4V180.665H124.665v52.873h24.493a17.067,17.067,0,0,0,3.46,2.8,18.337,18.337,0,0,0,4.16,1.866Zm37.322-8.553a8.369,8.369,0,1,0-6.1-2.449A8.284,8.284,0,0,0,161.988,229.651Zm15.862,10.575-8.332-8.32a15.256,15.256,0,0,1-3.525,1.749,12.13,12.13,0,0,1-4,.661A13.246,13.246,0,1,1,175.206,221.1a12.129,12.129,0,0,1-.661,4,15.257,15.257,0,0,1-1.749,3.525l8.32,8.332Z",
    transform: "translate(704 1130)",
    fill: "#182e7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentView);
export default __webpack_public_path__ + "static/media/document-view.1aefc9d7a6c4462746807ca3326c6b06.svg";
export { ForwardRef as ReactComponent };